export class VaultService {
  // Save to Resource Vault
  public saveToVault(data: any[], resourceInfo: {
    title: string;
    description: string;
    type: string;
    tags: string[];
    category?: string;
  }): void {
    try {
      console.log('saveToVault called with data:', data);
      console.log('Resource info:', resourceInfo);
      // Get existing resources from localStorage
      const existingResources = JSON.parse(localStorage.getItem('resourceVault') || '[]');
      
      // Create CSV content if data is an array
      let content: { type: string; data: string } | any[] = data;
      if (Array.isArray(data)) {
        const headers = Object.keys(data[0]);
        const csvContent = [
          headers.join(','),
          ...data.map(row => headers.map(header => row[header] || '').join(','))
        ].join('\n');
        content = {
          type: 'csv',
          data: csvContent
        };
      }
      
      // Create a new resource object
      const newResource = {
        id: `resource-${Date.now()}`,
        title: resourceInfo.title,
        description: resourceInfo.description,
        type: resourceInfo.type,
        category: resourceInfo.category || 'InsightRank Audits',
        content: content,
        dateCreated: new Date().toISOString().split('T')[0],
        dateAdded: new Date().toISOString(),
        favorite: false,
        tags: resourceInfo.tags
      };
      
      // Add the new resource to the existing ones
      existingResources.push(newResource);
      localStorage.setItem('resourceVault', JSON.stringify(existingResources));
      console.log('Saved to Resource Vault:', newResource);
    } catch (error) {
      console.error('Error saving to Resource Vault:', error);
      throw error;
    }
  }
}
